import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>FireGram</h1>
      <h2>FireGram Pictures</h2>
      <p>Photos Currently stored on FireStore Database</p>
    </div>
  )
}

export default Title;